export default {"src":"/_next/static/media/left_curve_arrow.d29b1fca.svg","height":7,"width":19,"blurWidth":0,"blurHeight":0};